module.exports = __webpack_public_path__ + "img/sa701lt.eebd4cab.svg";